module.exports = __webpack_public_path__ + "static/img/related-terms.b15871e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/related/related-terms.png
// module id = 802
// module chunks = 1